<template>
    <div v-loading="loading">
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <div class="flex">
                <el-form-item  prop="vc_code" label="标号" required>
                    <el-input :disabled="canEdit"  class="changeinput"  size="mini" placeholder="例：20250401" v-model="formData.vc_code"  ></el-input>
                </el-form-item>
                <el-form-item  prop="vc_type" label="标类型" required>
                    <!--<el-input :disabled="canEdit"  class="changeinput"  size="mini" placeholder="例：出口海运费" v-model="formData.vc_type"  ></el-input>-->
                    <el-select :disabled="canEdit"  @change="changeData($event,'temp')" class="changeinput" v-model="formData.vc_type" size="mini" @clear="cleardata('temp')"  clearable filterable >
                        <el-option
                                v-for="item in tempList"
                                :key="item.i_id"
                                :label="item.vc_keyname"
                                :value="item.vc_keyname">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item  prop="i_needsend" label="是否发送邮箱" required>
                <el-radio-group :disabled="canEdit"  v-removeAria v-model="formData.i_needsend">
                    <el-radio :label='0'>不发送</el-radio>
                    <el-radio :label='1'>发送</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item  prop="uids" label="供应商" :required="formData.i_needsend==1?true:false">
                <ul style="height:200px;overflow-y: auto;max-height: 200px"  @click="sendPer">
                    <li v-for="item in formData.suppliers">{{item.vc_name+(item.i_id!=0?'(':'')+item.vc_email+' '+item.vc_lxr+(item.i_id!=0?')':'')}}</li>
                </ul>
            </el-form-item>
            <el-form-item  prop="uids" label="接收人" required>
                <ul style="height:200px;overflow-y: auto;max-height: 200px"  @click="acceptPer">
                    <li v-for="item in formData.uids">{{item.vc_name}}</li>
                </ul>
            </el-form-item>
            <div class="flex">
                <el-form-item  prop="dt_deadline" label="截标时间" required>
                    <el-date-picker :disabled="canEdit"
                                    v-model="formData.dt_deadline"
                                    size="mini"
                                    class="changeinput"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="选择日期"
                                    default-time="16:00:00"
                    >
                        <!--:picker-options="pickerOptions"-->
                    </el-date-picker>
                </el-form-item>
                <el-form-item prop="vc_files"  label="模板附件" style="margin-bottom: 5px;margin-left: -12px" required>
                    <template v-if="(!formData.vc_files||JSON.stringify(formData.vc_files)=='{}')&&!canEdit">
                        <el-button  style="position: relative">上传附件<input type="file" name="files" value="" id="uploadfile3"
                         ref="uploadclear1"    class="uploadfile1" @change="uploadFile" /></el-button>
                    </template>
                    <!--<template v-if="formData.vc_files&&formData.vc_files.otherfiles.length!=0">
                        <div v-for="(file,index) in formData.vc_files.otherfiles">
                            <a
                                    :download="file.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.vc_newname+'\'}','utf-8')">
                                &lt;!&ndash;:herf="file"&ndash;&gt;     {{file.vc_name}}
                            </a>
                            <el-button @click="clearFile(file,index)" v-if="!canEdit">删除附件</el-button>
                        </div>
                    </template>-->
                    <template v-if="formData.vc_files&&JSON.stringify(formData.vc_files)!=='{}'">
                        <a

                                :download="formData.vc_files.vc_name"
                                mce_href="#"
                                :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+formData.vc_files.vc_newname+'\'}','utf-8')">
                            <!--:herf="file"-->     {{formData.vc_files.vc_name}}
                        </a>
                        <el-button @click="clearFile2()" v-if="!canEdit">删除附件</el-button>
                    </template>
                </el-form-item>

            </div>
           <!-- <div class="flex">
                <div class="flex" style="margin-left: 50px">
                    <el-upload
                            class="upload-demo"
                            style="padding-right: 20px"
                            :action="action"
                            :data="updata"
                            :http-request="beupload"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="10"
                            :file-list="fileList">
                        &lt;!&ndash;:limit="limit"
                            :on-exceed="handleExceed"&ndash;&gt;
                        <el-button size="mini" type="text">选择文件</el-button>
                    </el-upload>
                    <div>
                        <el-button :class="baseerp+'btn'" size="mini" type="primary" @click="submitUpload">上传</el-button>
                    </div>
                </div>
            </div>-->
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">编辑</el-button>
                <el-button type="primary" @click="saveForm('formRef')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-else>保存</el-button>
            </template>
            <el-button @click="cancel" size="small">取消</el-button>
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="500px"
                title="可发送名单"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible"
                :append-to-body="true">
            <ord-list :dataOrd="dataOrd" @cancelDialog="cancelDialog"></ord-list>
        </el-dialog>
        <el-dialog
                :class="baseerp+'div'"
                width="800px"
                title="供应商名单"
                :visible.sync="dialogVisible_gy"
                :close-on-click-modal="false"
                @close="cancelDialog_gy"
                v-if="dialogVisible_gy"
                :append-to-body="true">
            <supplier-list :dataGy="dataGy" @cancelDialog="cancelDialog_gy"></supplier-list>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import {erpplatserver} from "@/utils/baseUrl";
    import ordList from "./ordList";
    import supplierList from "./supplierList";
    export default {
        name: "DetailPage",
        components: {
            ordList,
            supplierList,
        },
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                dialogVisible_gy:false,
                dataGy:{},
                dialogVisible:false,
                dataOrd:{},
                loading:false,
                tempList:[],
                fileList:[],
                action:erpplatserver+'/system/uploadInvoice',
                updata:{
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                },
                /*pickerOptions: {
                    disabledDate(time) {
                        let curDate=(new Date()),perM;
                        if(curDate.getMonth()>0){
                            perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                        }else{
                            perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                        }
                        let today=(new Date()).getDate();
                        let same=today*24*3600*1000;
                        // let sameMonth=curDate-same;//当月月初
                        let sameMonth=perM;
                        return time.getTime() > Date.now() || time.getTime() < sameMonth;
                        // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                        // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的
                    }
                },*/
                i_id:0,
                formData:{
                    vc_files:{},
                    uids:[{i_id:0,vc_name:'请选择接收人'}],
                    suppliers:[{i_id:0,vc_name:'请选择供应商',vc_email:'', vc_lxr:''}],
                    i_needsend:1,
                },
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                canEdit:false,
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        if(!this.data.copydata){
                            //console.log("//////////")
                            this.canEdit=false;
                            this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");
                        }else{
                            this.formData=JSON.parse(JSON.stringify(this.data.copydata));
                            this.canEdit=true;
                            if(this.i_id==0){
                                this.formData.i_id=0;
                                this.formData.vc_code='';
                                this.formData.dt_deadline='';
                                this.formData.vc_files={};
                                let map={i_id:0,vc_name:'请选择接收人'};
                                if(this.formData.uids.length==0){
                                    this.formData.uids.push(map)
                                }
                                delete this.formData.vc_filejson;
                                this.canEdit=false;
                            }

                        }
                        //console.log(this.formData,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.i_uid= sessionStorage.getItem("userid");
            this.token=sessionStorage.getItem("token");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.getTemplist();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            cancelDialog_gy(val){
                this.dialogVisible_gy=false;
                this.dataGy={};
                if(val){
                    let map={i_id:0,vc_name:'请选择供应商',vc_email:'', vc_lxr:''};
                    this.formData.suppliers=val.multipleSelection;
                    if(val.multipleSelection.length==0){
                        this.formData.suppliers.push(map)
                    }
                }
            },
            cancelDialog(val){
                this.dialogVisible=false;
                this.dataOrd={};
                if(val){
                    let map={i_id:0,vc_name:'请选择接收人'};
                    this.formData.uids=val.multipleSelection;
                    if(val.multipleSelection.length==0){
                        this.formData.uids.push(map)
                    }
                }
            },
            beupload(obj){
                this.fileList.push(obj.file)
                //console.log(this.fileList, 'this.fileList');
            },
            handleRemove(obj, fileList) {
                this.fileList=fileList;
                //console.log(this.fileList, 'this.fileList');
                if(this.fileList.length==0){
                    this.vc_newname='';
                    this.vc_fpcode_upl='';
                    this.vc_pz_upl='';
                    this.f_pay_ws_upl='';
                    this.f_pay_zzs_upl='';
                    this.f_pay_upl='';
                    this.vc_note_upl='';
                    this.f_gs_upl='';
                }
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            /*clearFile(val,index){
                this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },*/
            clearFile2(){
                this.formData.vc_files={}
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            async uploadFile(e) {
                //console.log(e,'e')
                let that = this;
                that.loading = true;
                let i = 0;
                let $files = e.target.files[0];
                let fileName = $files.name;
                let type = $files.type;
                //console.log('type',type)
                var list = {
                    //"image/jpeg": true,
                    //"image/png": true,
                    //"image/jpg": true,
                    //"image/bmp": true,
                    //"application/pdf": true,
                    "application/vnd.ms-excel":true,
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":true,
                };
                let result = list[type];
                if(($files && result==false) || ($files &&result==undefined)){
                    //that.$message.error('请上传格式正确的文件');
                    that.$message.error('请上传格式正确的Excel文件');
                    that.loading = false;
                    return;
                };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "tenderpub",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "tenderpub",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("lruname"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        // this.filesImgList.push(res.data[0])
                        // this.filesList.push(res.data[0].i_id)
                        this.loading = false;
                        //匹配模板名称是否一致
                        let fjname=this.removeExtensionAndDash(res.data[0].filename);
                        let mobanname=this.formData.vc_code+this.formData.vc_type;
                        //console.log(fjname,'fjname')
                        //console.log(mobanname,'mobanname')
                        if(fjname!=mobanname){
                            that.$message.error('招标编号类型与附件名称不一致！');
                            //return;
                        }
                        let file={
                            i_id:res.data[0].i_id,
                            vc_name:res.data[0].filename,
                            vc_newname:res.data[0].filenewname,
                            vc_path:res.data[0].vc_path
                        }
                        //this.formData.vc_files.otherfiles.push(file);
                        this.formData.vc_files=file;
                        this.$forceUpdate()
                        // console.log(this.leaveList[index])
                    } else if (res.code == -2) {
                        this.loading = false;
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.loading = false;
                        this.$message.error(res.message);
                    }
                }
            },
            removeExtensionAndDash(filename) {
                // Remove the file extension, which is anything after the last '.'
                let nameWithoutExtension = filename.replace(/\.[^.]*$/, '');
                // Remove the '-' character, if it exists
                let finalName = nameWithoutExtension.replace(/-/g, '');
                return finalName;
            },
            editForm(){
                this.canEdit=false
            },
            saveForm(data){
                this.$refs[data].validate((valid)=>{
                    if(valid){
                        //console.log(this.formData)
                        let len_s=this.formData.suppliers.filter(item=>item.i_id!=0).length
                        //console.log(len_s,'len_s')
                        if(this.formData.i_needsend==1&&len_s==0){
                            this.$message.error('请选择供应商！');
                            return;
                        }
                        let len=this.formData.uids.filter(item=>item.i_id!=0).length
                        //console.log(len,'len')
                        if(len==0){
                            this.$message.error('请选择接收人！');
                            return;
                        }
                        if(JSON.stringify(this.formData.vc_files)=='{}'){
                            this.$message.error('请上传模板附件！');
                            return;
                        }
                        //匹配模板名称是否一致
                        let fjname=this.removeExtensionAndDash(this.formData.vc_files.vc_name);
                        let mobanname=this.formData.vc_code+this.formData.vc_type;
                        //console.log(fjname,'fjname')
                        //console.log(mobanname,'mobanname')
                        if(fjname!=mobanname){
                            this.$message.error('招标编号类型与附件名称不一致！');
                            return;
                        }
                        let pers='';
                        let arr=[];
                        this.formData.uids.map(item=>{
                            arr.push(item.vc_name)
                        })
                        pers=arr.toString()
                        this.$confirm(`该招标将在${this.formData.dt_deadline}开标,系统将自动推送开标数据给${pers},是否确定?`,'提示',{
                            confirmButtonText:'确定',
                            cancelButtonText:'取消',
                            type:'warning'
                        }).then(()=>{
                            this.savePayment()
                        }).catch(()=>{

                        })

                    }else{
                        return false;
                    }
                })
                /*if(this.formData.i_khid==''||this.formData.i_khid==undefined||this.formData.i_gsid==''||(this.formData.i_isbankcharges===0&&this.formData.vc_bank_account=='')||this.formData.f_pay==0||this.formData.f_rate==0){
                    this.$message.warning('请填写必需项')
                }else{
                    if(this.formData.i_id==0){
                        this.savePayment()
                    }else{
                        this.formData.i_cid=this.formData.i_khid
                        this.formData.vc_cname=this.formData.vc_khname
                        this.updateHistoryPayment()
                    }
                    this.disabled=true
                }*/
            },
            cancel(){
                this.$emit('close')
            },
            cleardata(type){
                if(type=='temp')this.getTemplist();
            },
            changeData(e,type){
                //console.log('e',e)
                if(type=='temp'){
                    let choo = this.tempList.filter(item=>{
                        return item.vc_keyname == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_type=choo[0].vc_keyname;
                        this.formData.vc_email_send=choo[0].vc_email;//发布邮箱
                        this.formData.vc_rpt_type=choo[0].vc_rpt_type;//报表类型
                    }else{
                        this.formData.vc_type='';
                        this.formData.vc_email_send='';//发布邮箱
                        this.formData.vc_rpt_type='';//报表类型
                    }
                }
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            sendPer(){
                if(!this.formData.vc_type||this.formData.vc_type==''){
                    this.$message.error('请先选择标类型！');
                    return;
                }
                let arr=[];
                arr=this.formData.suppliers.filter(item=>item.i_id!=0);
                this.dataGy={
                    vc_type:this.formData.vc_type,
                    choo:arr,
                }
                this.dialogVisible_gy=true;
            },
            acceptPer(){
                let arr=[];
                arr=this.formData.uids.filter(item=>item.i_id!=0);
                this.dataOrd={
                    choo:arr,
                }
                this.dialogVisible=true;
            },
            //temp列表
            async getTemplist(){
                let param={
                    i_mid:this.mid,
                };
                let res=await API.tenderType(param);
                if(res.code==1){
                    this.tempList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.$message.error(res.message);
                }
            },

            async savePayment(){
                let list = [];
                list.push(this.formData)
                let param={
                    list:list
                };
                //console.log('param',param)
                let res=await API.tendersave(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            /*async updateHistoryPayment(){
                let param={
                    i_id:this.formData.i_id,
                    i_cid:this.formData.i_cid,
                    i_gsid:this.formData.i_gsid,
                    vc_gsaccount:this.formData.vc_gsaccount,
                    vc_cname:this.formData.vc_cname,
                    vc_name_bank:this.formData.vc_name_bank,
                    i_hpstatus:this.formData.i_hpstatus,
                    vc_type:this.formData.vc_type,
                };
                let res=await API.updateHistoryPayment(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },*/
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    /deep/.number .el-input__inner{
        text-align: left !important;
    }
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-around;

    }
    .changeinput{
        width: 200px;
        display: inline-block;
    }
</style>